// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"1ef894f9","413":"9b31c895","577":"38c54c32"}[chunkId] + ".chunk.css";
};